import styled from 'styled-components';
import { useHistory } from 'react-router-dom';
import { useTheme } from '@mui/material';

const SignSection = ({ signer }) => {
  const history = useHistory();
  const theme = useTheme();

  const handleSignClick = () => {
    history.push(`/hellosign-embedded-sign/${signer.signature_id}`);
  };

  return (
    <>
      {signer.status_code === 'ready_to_sign' && (
        <SignButton onClick={handleSignClick} theme={theme}>
          sign
        </SignButton>
      )}
    </>
  );
};

export default SignSection;

const SignButton = styled.button`
  color: ${({ theme }) => theme.palette.blue.medium};
  text-decoration: underline;
  text-transform: capitalize;
  border: none;
  background-color: transparent;
  font-size: 13px;

  grid-column: 4 / span 1;
  justify-self: end;

  &:hover {
    color: ${({ theme }) => theme.palette.blue.dark};
    text-decoration: none;
  }
`;
